module.exports = __webpack_public_path__ + "img/logo.171f12a3.png";